module.exports = __webpack_public_path__ + "media/summer.15ab49b3.mp3";